export default {

  formatDateStr: function (time) {
    var date = new Date(time);
    return formatDate(date, 'yyyy-MM-dd hh:mm');
  },

  formatDateWithFormat: function (time, str) {
    var date = new Date(time);
    return formatDate(date, str);
  },

  // 判断字符是否为空的方法
  isEmpty (obj) {
    if (typeof obj == "undefined" || obj == null || obj == "" || obj == '') {
      return true;
    } else {
      return false;
    }
  },
  // 格式化文件大小
  formatFileSize: function (fileSize) {
    var temp = 0;
    if (fileSize < 1024) {
      return fileSize + "B";
    } else if (fileSize < 1024 * 1024) {
      temp = fileSize / 1024;
      temp = temp.toFixed(2);
      return temp + "KB";
    } else if (fileSize < 1024 * 1024 * 1024) {
      temp = fileSize / (1024 * 1024);
      temp = temp.toFixed(2);
      return temp + "MB";
    } else {
      temp = fileSize / (1024 * 1024 * 1024);
      temp = temp.toFixed(2);
      return temp + "GB";
    }
  },
  changeTitle (title) {
    setTimeout(() => {
      // 利用iframe的onload事件刷新页面
      document.title = title
      var iframe = document.createElement('iframe')
      iframe.style.visibility = 'hidden'
      iframe.style.width = '1px'
      iframe.style.height = '1px'
      iframe.onload = function () {
        setTimeout(function () {
          document.body.removeChild(iframe)
        }, 0)
      }
      document.body.appendChild(iframe)
    }, 0)
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js